import { BrowserRouter, Navigate, Route, Routes, useSearchParams } from "react-router-dom";

import { ConsolePage } from "./pages/ConsolePage";
import { ViewerPage } from "./pages/ViewerPage";
import styles from "./App.module.scss";

function ViewerRedirect() {
  const [params] = useSearchParams();
  const room = (params.get("room") || "").trim();
  if (!room) {
    return (
      <main className={styles.fallback}>
        Укажите комнату: <code>/viewer?room=demo-room</code> или <code>/view/demo-room</code>
      </main>
    );
  }
  return <Navigate to={`/view/${encodeURIComponent(room)}`} replace />;
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/view/:sessionId" element={<ViewerPage />} />
        <Route path="/observe/:sessionId" element={<ViewerPage monitorOnly />} />
        <Route path="/xr/:sessionId" element={<ViewerPage xrInputOnly />} />
        <Route path="/console/:sessionId" element={<ConsolePage />} />
        <Route path="/viewer" element={<ViewerRedirect />} />
        <Route path="/" element={<Navigate to="/view/demo-room" replace />} />
        <Route path="*" element={<Navigate to="/view/demo-room" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
